<div>
    <div class="container-fluid">
        <form [formGroup]="formGroup" ngNativeValidate>
            <form-layout [content]="formData.columns"></form-layout>
        </form>
    </div>
</div>